import React from 'react';
import { Icon, IconProps } from './Icon';

export const CloudUploadIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon height="24" width="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 13v8" />
      <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
      <path d="m8 17 4-4 4 4" />
    </Icon>
  );
};
